import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_METHOD_TIME } from 'api/notificationManager/methods';

export default class TimeRequest extends WsBaseRequest {
  constructor() {
    super(API_METHOD_TIME, {});
  }
}
